import React, { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useQuery, useSubscription } from "@apollo/client/react";

import { ASSETS_COLLECTION_QUERY, INVENTORY_ASSET_STOCKED } from "../../../constants/graphql";
import Filter from "../../../views/shopping/ProjectAssets/Filter";
import Results from "../../../views/shopping/ProjectAssets/Results";
import { initialValues } from "../../../views/shopping/ProjectAssets/DefaultItems";
import { ShoppingProvider } from "../../../contexts/shopping";

const INITIAL_FILTER = {
  search: "",
  limit: 24,
  page: 1,
  categories: [],
  hideDepletedAssets: true,
};

export const ProjectBrowseView = ({ projectId, processNewItem }) => {
  const [filter, setFilter] = useState(INITIAL_FILTER);
  const [assets, setAssets] = useState([]);
  const [metadata, setMetadata] = useState({});
  const [loading, setLoading] = useState(true);
  const [defaultValues] = useState(initialValues);

  const variables = useMemo(
    () => ({
      ...filter,
      storePage: true,
      ...(projectId && { projectId }),
    }),
    [filter, projectId]
  );

  const { data: collectionData, refetch } = useQuery(ASSETS_COLLECTION_QUERY, {
    variables,
  });
  const { categories = [] } = collectionData || {};

  useEffect(() => {
    if (collectionData) {
      const { assetsCollection = {} } = collectionData;
      setAssets(assetsCollection?.collection);
      setMetadata(assetsCollection?.metadata || {});
      setLoading(false);
    }
  }, [collectionData]);

  useEffect(() => {
    setLoading(true);
    refetch({ ...filter }).then(() => setLoading(false));
  }, [filter, projectId]);

  useSubscription(INVENTORY_ASSET_STOCKED, {
    onData: ({ data: { data: { inventoryAssetStocked } = {} } = {} }) => {
      const existingAssetIndex = _.findIndex(assets, asset => asset.id == inventoryAssetStocked.id);
      if (existingAssetIndex == null) return;
      setAssets(prevAssets =>
        Object.assign([], prevAssets, {
          [existingAssetIndex]: inventoryAssetStocked,
        })
      );
    },
  });

  const onChangeFilter = newFilter => setFilter({ ...filter, ...newFilter });

  return (
    <>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Filter
            categories={categories}
            filter={filter}
            disabled={loading}
            onChange={onChangeFilter}
          />
        </Grid>
      </Grid>
      <Box mt={2}>
        <Results
          defaultValues={defaultValues}
          disabled={loading}
          hideDepletedAssets={filter.hideDepletedAssets}
          onChange={onChangeFilter}
          loading={loading}
          assets={assets}
          pagination={metadata}
          processNewItem={processNewItem}
        />
      </Box>
    </>
  );
};

export default ({ projectId, processNewItem }) => (
  <ShoppingProvider>
    <ProjectBrowseView projectId={projectId} processNewItem={processNewItem} />
  </ShoppingProvider>
);
